import { colors } from '@insurancemenu/imenu-components-lib';
import { ComponentStylesProps } from '@insurancemenu/imenu-components-lib/dist/types';
import { createUseStyles } from 'react-jss';
import { FilterCardPropsType } from './index';

const styles: ComponentStylesProps<FilterCardPropsType> = {
  filterCard: {
    backgroundColor: colors.neutral.white,
    height: '7.2rem',
    borderRadius: '6px',
    padding: '1.2rem 0rem 0.8rem 0rem',
    textAlign: 'center',
    color: colors.neutral[900],
    boxSizing: 'border-box',
    cursor: 'pointer',
  },
  filterCardTitle: {
    font: { size: '1.2rem', lineHeight: '1.8rem', weight: 700 },
    marginTop: 0,
    marginBottom: '0.2rem',
    textTransform: 'uppercase',
  },
  filterCardQuantity: { font: { size: '2.4rem', lineHeight: '3.2rem', weight: 700 }, margin: 0 },

  // Not Active filter cards
  filterCard_ALL: { border: `0.2rem solid ${colors.blue[600]}` },
  filterCard_NEW_LEAD: { border: `0.2rem solid ${colors.green[300]}` },
  filterCard_QUOTING: { border: `0.2rem solid ${colors.purple[300]}` },
  filterCard_ENROLLING: { border: `0.2rem solid ${colors.yellow[200]}` },
  filterCard_SUBMITTED: { border: `0.2rem solid ${colors.blue[300]}` },
  filterCard_RENEWAL: { border: `0.2rem solid ${colors.orange[300]}` },
  filterCard_SOLD: { border: `0.2rem solid ${colors.indigo[600]}` },
  filterCard_ARCHIVED: { border: `0.2rem solid ${colors.neutral[400]}` },
  filterCard_DORMANT: { border: `0.2rem solid ${colors.red[800]}` },
  filterCard_ACTIVE: { border: `0.2rem solid ${colors.red[200]}` },
  filterCard_INVITED: { border: `0.2rem solid ${colors.purple[400]}` },

  // Active filter cards
  filterCardActive_ALL: { backgroundColor: colors.blue[600], color: colors.neutral.white },
  filterCardActive_NEW_LEAD: { backgroundColor: colors.green[300] },
  filterCardActive_QUOTING: { backgroundColor: colors.purple[300] },
  filterCardActive_ENROLLING: { backgroundColor: colors.yellow[200] },
  filterCardActive_SUBMITTED: { backgroundColor: colors.blue[300] },
  filterCardActive_RENEWAL: { backgroundColor: colors.orange[300] },
  filterCardActive_SOLD: { backgroundColor: colors.indigo[600], color: colors.neutral.white },
  filterCardActive_ARCHIVED: { backgroundColor: colors.neutral[400], color: colors.neutral.white },
  filterCardActive_DORMANT: { backgroundColor: colors.red[800], color: colors.neutral.white },
  filterCardActive_ACTIVE: { backgroundColor: colors.red[200] },
  filterCardActive_INVITED: { backgroundColor: colors.purple[400] },
};

const createStyles = createUseStyles(styles);

export { styles, createStyles };
